import _ from 'lodash';

import { DEFAULT_DECIMAL_SCALE } from 'constants/number';

import { getConditionalObject } from './data';

const formatNumberByParams = (value, options) => {
  if (options.isNullishDisallowed && _.isNil(value)) {
    return value;
  }

  const absValue = Math.abs(value);
  const hasDecimalPart = absValue % 1 !== 0;

  const formattedOptions = {
    ...options,
    ...getConditionalObject(options.omitFractionIfInteger && !hasDecimalPart, {
      minimumFractionDigits: 0,
    }),
  };

  const formattedValue = new Intl.NumberFormat('en-US', formattedOptions).format(absValue);

  if (value < 0) {
    return formattedOptions.isAccountingFormat ? `(${formattedValue})` : `-${formattedValue}`;
  }

  return formattedValue;
};

export const formatNumberToFixed3Decimals = value =>
  formatNumberByParams(value, {
    minimumFractionDigits: 3,
    maximumFractionDigits: 3,
  });

export const formatNumberToFixed3DecimalsExceptNull = value =>
  formatNumberByParams(value, {
    isNullishDisallowed: true,
    minimumFractionDigits: 3,
    maximumFractionDigits: 3,
  });

export const formatNumberToFixed2DecimalsExceptNull = value =>
  formatNumberByParams(value, {
    isNullishDisallowed: true,
    minimumFractionDigits: DEFAULT_DECIMAL_SCALE,
    maximumFractionDigits: DEFAULT_DECIMAL_SCALE,
  });

export const formatNumberToFixed2DecimalsMax = value =>
  formatNumberByParams(value, {
    isNullishDisallowed: true,
    minimumFractionDigits: 0,
    maximumFractionDigits: DEFAULT_DECIMAL_SCALE,
  });

export const formatNumberToCurrencyString = (value, options) =>
  formatNumberByParams(value, {
    minimumFractionDigits: DEFAULT_DECIMAL_SCALE,
    maximumFractionDigits: DEFAULT_DECIMAL_SCALE,
    ...options,
    style: 'currency',
    currency: 'USD',
  });

export const onIsAllowedNumberField =
  ({ integerPart, decimalScale }) =>
  ({ value }) => {
    const hasDecimal = value.indexOf('.') !== -1;

    const [integer, decimal] = value.split('.');

    if (hasDecimal) {
      return integer?.length <= integerPart && decimal.length <= decimalScale;
    }

    return value?.length <= integerPart;
  };

export const roundToDecimals = (num, decimals = 2) => Number(num.toFixed(decimals));

export const getNumber = value => Number(value.replace(/,/g, '')) || 0;
